import { render, staticRenderFns } from "./InsolvencyMessages.vue?vue&type=template&id=b0aa5e08&scoped=true&"
import script from "./InsolvencyMessages.vue?vue&type=script&lang=js&"
export * from "./InsolvencyMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0aa5e08",
  null
  
)

export default component.exports